import tw from './zh-tw/index.js'
import cn from './zh-cn/index.js'
import en from './en-us/index.js'

const messages = {
  'zh-tw' : tw,
  'zh-cn' : cn,
  'en-us' : en
}

export default messages
